// @ts-check
import React from 'react';
import PropTypes from 'prop-types';
import {
  wrapFormComponentWithLabelAndError,
  wrapFormComponentWithError,
} from './StyledFormComponentWrappers';
import connectFormComponentToReduxForm from 'utils/connectFormComponentToReduxForm';
import normalizePhone from 'utils/normalizePhone';
import MaskedInput from 'react-text-mask';

const RawPhoneMaskInput = ({ name, ...otherInputProps }) => (
  <MaskedInput
    name={name}
    id={name}
    type="text"
    className="input-large"
    placeholder="(xxx) xxx-xxxx"
    mask={['(', /[1-9]/, /\d/, /\d/, ')', ' ', /\d/, /\d/, /\d/, '-', /\d/, /\d/, /\d/, /\d/]}
    {...otherInputProps}
  />
);

RawPhoneMaskInput.propTypes = {
  name: PropTypes.string.isRequired,
};

RawPhoneMaskInput.displayName = 'RawPhoneMaskInput';

export { RawPhoneMaskInput };

/**
 * NB: The `normalize` function passed to Field strips the input
 * value of non-numeric characters so a "clean" value is
 * stored in redux, rather than the "masked" value.
 */
const PhoneMaskInput = connectFormComponentToReduxForm(
  wrapFormComponentWithError(RawPhoneMaskInput),
  { normalize: normalizePhone }
);

PhoneMaskInput.displayName = 'PhoneMaskInput';

export { PhoneMaskInput };

const RawPhoneMaskField = wrapFormComponentWithLabelAndError(RawPhoneMaskInput);
RawPhoneMaskField.displayName = 'RawPhoneMaskField';

export { RawPhoneMaskField };

/**
 * NB: The `normalize` function passed to Field strips the input
 * value of non-numeric characters so a "clean" value is
 * stored in redux, rather than the "masked" value.
 */
const PhoneMaskField = connectFormComponentToReduxForm(RawPhoneMaskField, {
  normalize: normalizePhone,
});
PhoneMaskField.displayName = 'PhoneMaskField';

export default PhoneMaskField;
